import * as React from "react";
const SvgMenu = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M3 5h18v2H3zm0 6h18v2H3zm0 6h18v2H3z" })));
export default SvgMenu;
//# sourceMappingURL=Menu.js.map